import { c as _c } from "react/compiler-runtime";
interface SepoliaIconProps {
  className?: string;
}
export function SepoliaIcon(t0) {
  const $ = _c(5);
  const {
    className
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <rect width="100" height="100" x=".5" y=".5" fill="#fff" rx="50" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <g stroke="#1616B4" strokeLinejoin="round" strokeWidth=".461" clipPath="url(#a)"><path fill="#F0CDC2" d="M50.504 91.974v-20.81L24.76 56.107l25.744 35.866Z" /><path fill="#C9B3F5" d="M50.59 91.974v-20.81l25.744-15.056L50.59 91.974Z" /><path fill="#88AAF1" d="M50.504 65.991v-26.56l-26.04 11.66 26.04 14.9Z" /><path fill="#C9B3F5" d="M50.59 65.991v-26.56l26.04 11.66-26.04 14.9Z" /><path fill="#F0CDC2" d="m24.465 51.09 26.04-42.065V39.43l-26.04 11.66Z" /><path fill="#B8FAF6" d="M76.63 51.09 50.59 9.025V39.43l26.04 11.66Z" /></g>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <defs><clipPath id="a"><path fill="#fff" d="M24.004 8.564h52.995v83.871H24.004z" /></clipPath></defs>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== className) {
    t4 = <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 101 101" className={className}>{t1}{t2}{t3}</svg>;
    $[3] = className;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
}